// @ts-strict-ignore
import * as React from 'react';
import { useRef } from 'react';
import { Directions } from 'common/components/drop-menu/types';
import { SelectTheme } from 'common/components/select/constants';
import { SelectReact } from 'common/components/select';
import { withStyles } from 'common/util/react';
import { InputComponent, InputReact } from 'common/components/input';
import { InputType } from 'common/components/input/types';
import { parseNumber } from 'common/util';
import { useTranslation } from 'common/i18n/hooks';
import styles from './index.module.styl';
import css from './index.module.styl?inline';
const Steps = React.forwardRef<InputComponent, {
  className: string;
  steps: number;
  label: string;
  onChange: (steps: number) => void;
}>((props, ref) => {
  var _props$steps;
  return <div className={props.className}>
    <div className={styles.label}>{props.label}</div>
    <InputReact ref={ref as any} className={styles.input} type={InputType.Number} min='0' max='99' showNumericInputControls value={((_props$steps = props.steps) !== null && _props$steps !== void 0 ? _props$steps : 0).toString()} onChange={ev => {
      const number = parseNumber(ev.detail.value);
      if (number !== null) {
        props.onChange(number);
      } else {
        ev.detail.value = props.steps.toString();
      }
    }} />
  </div>;
});
export const NumberOfSteps = withStyles((props: {
  forward: number;
  reverse: number;
  onChangeForward: (steps: number) => void;
  onChangeReverse: (steps: number) => void;
}) => {
  const {
    t,
    formatList
  } = useTranslation();
  const beforeEl = useRef<InputComponent>();
  return <SelectReact theme={SelectTheme.Tertiary} alwaysShowCaret selectedOption={formatList([t("flows.step-range.steps-before", {
    count: props.reverse
  }), t("flows.step-range.steps-after", {
    count: props.forward
  })], "unit")} menuAlignment={Directions.Down} onMenuChange={() => {
    var _beforeEl$current;
    return (_beforeEl$current = beforeEl.current) === null || _beforeEl$current === void 0 ? void 0 : _beforeEl$current.focus();
  }}>
        <div className={styles.dropdown} slot='body'>
          <div className={styles.title}>{t("flows.steps")}</div>
          <div className={styles.subtitle}>{t("flows.step-range.description")}</div>
          <div className={styles.stepsContainer}>
            <Steps ref={beforeEl} className={styles.beforeSteps} steps={props.reverse} label={t("flows.step-range.before")} onChange={steps => props.onChangeReverse(steps)} />
            <Steps className={styles.afterSteps} steps={props.forward} label={t("flows.step-range.after")} onChange={steps => props.onChangeForward(steps)} />
          </div>
        </div>
      </SelectReact>;
}, css);